import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from 'styles/pages/DrivingRange.module.scss';


export default function DrivingRangeSkeleton() {
  const listsToRender = 8;

    return (
      <div>
          <table className={styles.skeleton_table_bar}>
             <thead>
                  <tr>
                    <th className={styles.name}>NAME</th>
                    <th className={styles.city}>CITY</th>
                    <th className={styles.state}>STATE</th>
                    <th className={styles.country}>COUNTRY</th>
                    <th className={styles.modyfied}>LAST MODIFIED</th>
                    <th className={styles.action}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
        {Array(listsToRender).fill(1)
          .map((card, index) => (
            <tr>
                           <td className={styles.name_cont}>
                           <Skeleton height={40} />
                             <div className={styles.city_box}>
                             <td> <Skeleton height={40} /></td>
                             </div>
                           </td>
                           <td className={styles.city_cont}> <Skeleton height={40} /></td>
                           <td className={styles.state_cont}> <Skeleton height={40} /></td>
                           <td className={styles.country_cont}> <Skeleton height={40} /></td>
                           <td className={styles.modified_cont}> <Skeleton height={40} /></td>
                           <td className={styles.action_cont}> <Skeleton height={40} /></td>
                         
                          
                         </tr>
          ))}
          </tbody>
      </table>
      </div>
    
    );
}